import { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { fetchOrgStats } from '../../api/analytics';
import type { OrgStats } from '../../api/analytics';
import { FederalView } from './FederalView';
import { CantonView } from './CantonView';
import { CommuneView } from './CommuneView';
import styles from './OrgAnalyticsPage.module.css';

export function OrgAnalyticsPage() {
  const { orgId } = useParams<{ orgId: string }>();
  const [data, setData] = useState<OrgStats | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');

  useEffect(() => {
    if (!orgId) return;
    setLoading(true);
    setError('');
    fetchOrgStats(orgId)
      .then(setData)
      .catch(() => setError('Failed to load analytics'))
      .finally(() => setLoading(false));
  }, [orgId]);

  if (loading) return <div className={styles.loading}>Loading analytics...</div>;
  if (error) return <div className={styles.error}>{error}</div>;
  if (!data) return null;

  const { level } = data.organization;

  return (
    <div className={styles.page}>
      <div className={styles.breadcrumb}>
        <span>Analytics</span>
        <span>/</span>
        <span>{data.organization.name}</span>
      </div>
      <h2 className={styles.pageTitle}>{data.organization.name}</h2>

      {level === 'federal' && <FederalView data={data} />}
      {level === 'canton' && <CantonView data={data} />}
      {level === 'commune' && <CommuneView data={data} />}
    </div>
  );
}
